import { Star, Quote } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";

const REVIEWS = [
  {
    quote:
      "Our block was an awkward shape and other builders wouldn't touch it. ArcView's architect turned it into a home we honestly never thought was possible on our land.",
    name: "Michael R.",
    suburb: "Tarneit",
  },
  {
    quote:
      "The in-house architect is a genuine talent. He listened to how we live and designed every room around us, then kept everything moving through the approval departments for us.",
    name: "Priya S.",
    suburb: "Fraser Rise",
  },
  {
    quote:
      "We had run into problems with our build and ArcView stepped in and sorted out what others couldn't. The difference in workmanship and communication was night and day.",
    name: "Jake W.",
    suburb: "Werribee",
  },
  {
    quote:
      "One team from the first sketch to handover day. Everyone knew our project inside out, and we never had to chase anyone for answers.",
    name: "Sarah D.",
    suburb: "Point Cook",
  },
  {
    quote:
      "Our sloping block had everyone beaten. Their unique thinking and design made the most of every metre, and the plans lined up neatly with all the approval requirements.",
    name: "Daniel K.",
    suburb: "Truganina",
  },
  {
    quote:
      "Professional, warm and honest from day one. They treated our home like their own, and the finish quality is something we show off to every visitor.",
    name: "Lisa M.",
    suburb: "Hoppers Crossing",
  },
];

export default function Reviews() {
  return (
    <section className="bg-sand py-24 sm:py-32" data-testid="reviews-section">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <Reveal>
              <p className="eyebrow text-arc mb-6">Client Reviews</p>
            </Reveal>
            <MaskedLines
              className="font-serif font-medium tracking-tight leading-[1.05] text-charcoal text-4xl sm:text-5xl lg:text-6xl"
              lines={[<>What Our</>, <><span className="italic text-gradient">Clients Say.</span></>]}
            />
          </div>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-mist leading-relaxed">
              Homeowners across Tarneit, Melbourne's west and beyond — including clients with
              irregular blocks and tricky builds — on working with the ArcView team.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={(i % 3) * 0.08} className="h-full">
              <figure
                className="h-full bg-cream border border-line p-8 flex flex-col hover:border-arc/40 hover:shadow-xl hover:shadow-charcoal/5 hover:-translate-y-1.5 transition-all duration-500"
                data-testid={`review-card-${i + 1}`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex gap-1" aria-label="5 out of 5 stars">
                    {[0, 1, 2, 3, 4].map((s) => (
                      <Star key={s} size={15} className="fill-arcorange text-arcorange" />
                    ))}
                  </div>
                  <Quote size={22} className="text-arc/25" />
                </div>
                <blockquote className="mt-5 flex-1">
                  <p className="font-serif italic text-lg leading-relaxed text-charcoal">
                    "{r.quote}"
                  </p>
                </blockquote>
                <figcaption className="mt-6 pt-5 border-t border-line">
                  <p className="font-semibold text-charcoal text-sm" data-testid={`review-author-${i + 1}`}>{r.name}</p>
                  <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-mist mt-1">{r.suburb}, VIC</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
